<template>
  <div class="review-box">
    <div class="form">
      <div class="review-result">
        <div class="label">审核结果</div>
        <div class="content">
          <van-radio-group v-model="resultRadio" direction="horizontal">
            <van-radio name="1">
              通过
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
            <van-radio name="2">
              不通过
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="supplement-box">
        <p class="title">补充说明
          <span style="color: #F94F4E;font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;">*</span>
        </p>
          <van-field
            class="textarea"
            v-model="txt"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入"
          />
        <!-- <textarea
          v-model="txt"
          class="textarea"
          placeholder="请输入"
          cols="30"
          rows="10"
          maxlength="500"
        ></textarea> -->
        <div class="tip">{{ txt.length }}/500</div>
      </div>
    </div>
    <div class="btn-box">
      <div class="btn" :class="{'btndisable': !txt}" @click="confirm">确定</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.review-box {
  .header {
    background-color: #f2f2f2;
    padding: 16px;
    p {
      line-height: 25px;
    }
  }
  .form {
    padding: 0 16px;
    .review-result {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .address-inp-icon {
        width: 16px;
        height: 16px;
        position: relative;
        right: 28px;
      }
      .address-inp {
        background-color: white;
        width: 100%;
        height: 44px;
        padding-right: 28px;
        padding-left: 15px;
      }
      .label {
        font-size: 14px;
        color: #666666;
        span {
          color: red;
          vertical-align: middle;
          margin-left: 2px;
        }
      }
      /deep/.content {
        .van-field__control {
          text-align: right;
        }
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
          width: 18px;
          height: 18px;
        }
        span {
          font-size: 14px;
          color: #171a1d;
        }
        .arrow {
          font-size: 16px;
          vertical-align: sub;
          margin-left: 5px;
        }
      }
    }
    .supplement-box {
      position: relative;
      padding: 0;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
          .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding: 10px 16px 16px 0;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
      }
      .textarea {
        width: 100%;
        height: 160px;
        background: #f8f9fb;
        padding: 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
  .btn-box {
    padding: 0 16px;
    position: fixed;
    width: 100%;
    bottom: 20px;
    .btn {
      background-color: #37b375;
      padding: 16px 0;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
    }
    .btndisable {
      opacity: 0.5;
    }
  }
}
</style>
<script>
    import api from '../../../../service/modules/refund';
    export default {
        data () {
            return {
                resultRadio: '1',
                activeIcon: require('../../../../assets/refund/checkbox-select.png'),
                inactiveIcon: require('../../../../assets/refund/checkbox-defalut.png'),
                detail: {}, // 退货单详情
                txt: ''
            };
        },
        created () {
            this.detail = this.$route.query.data;
        },
        methods: {
            // 确定
            confirm () {
                try {
                    if (!this.txt) {
                        return this.$Toast({
                            message: '请填写补充说明'
                        });
                    }
                    const param = {
                        flowId: this.detail.flowId,
                        status: this.resultRadio === '1' ? 1 : 0,
                        content: this.txt
                    };
                    api.complainFeedbackAudio(param).then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: res.msg
                            });
                            setTimeout(() => {
                                this.$router.back();
                            }, 1500);
                        } else {
                            this.$Toast({
                                message: res.msg
                            });
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };
</script>
